module.exports = __webpack_public_path__ + "img/english-first.9ec6ba91.svg";